import React, { useState } from 'react';
// import { Button } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import Button from 'newComponents/Button';
import { getWhatsappUserInfo, getWhatsappReleased } from 'util/isAdmin';
import { useMessage } from 'newComponents/ChatWhatsapp/context/MessageContext';
import { CircularProgress } from '@mui/material';

const ConnectionStatus = ( { status, qrCode } ) => {
	const { handleCreateSession, handleRecreateSession, connectionPhase } = useMessage();
	const [ getQrCode, setGetQrCode ] = useState( false );
	const [ isLoadingNewQrCode, setIsLoadingNewQrCode ] = useState( false );
	const [ isCreatingSession, setIsCreatingSession ] = useState( false );

	// AFCO-417: mesma proteção do botão "+" da tela de Telefones — sem ela, cada
	// clique repetido abria outra geração de QR Code e derrubava a anterior.
	const isConnecting = connectionPhase === 'connecting';

	const handler = async () => {
		if ( isCreatingSession ) {
			return;
		}
		setIsCreatingSession( true );
		setGetQrCode( true );
		try {
			await handleCreateSession();
		} finally {
			setIsCreatingSession( false );
		}
	};

	const handlerRecreateSession = async () => {
		if ( isLoadingNewQrCode || isConnecting ) {
			return;
		}
		setIsLoadingNewQrCode( true );
		try {
			await handleRecreateSession();
		} finally {
			setIsLoadingNewQrCode( false );
		}
	};

	const userCanCreateSession = getWhatsappReleased() && getWhatsappUserInfo()?.profile_type_id === 1;

	return (
		<div style={{
			display        : 'flex',
			flexDirection  : 'column',
			alignItems     : 'center',
			justifyContent : 'center',
			height         : '100%',
			padding        : '20px',
			textAlign      : 'center',
			color          : '#333'
		}}>
			{ getQrCode && !status.isAuthenticated && isConnecting && (
				<>
					<h2>QR Code lido com sucesso!</h2>
					<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '14px', height: '350px', justifyContent: 'center' }}>
						<CircularProgress />
						<p style={{ fontSize: '14px', color: '#666' }}>
							Estabelecendo a conexão com o WhatsApp. Isso pode levar alguns segundos.
						</p>
					</div>
				</>
			)}
			{ getQrCode && !status.isAuthenticated && !isConnecting && (
				<>
					<h2>WhatsApp não autenticado</h2>
					{qrCode ? (
						<>
							<p>Por favor, escaneie o QR Code com seu WhatsApp para conectar:</p>
							{!isLoadingNewQrCode ? <div style={{ marginTop: '20px' }}>
								<img 
										src={qrCode} 
										alt="QR Code"
										style={{
											width   : '256px',
											height  : '256px',
											display : 'block',
											margin  : 'auto'
										}}
									/>
								<p style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
									Aguardando leitura do QR Code...
								</p>
							</div> : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '350px' }}>
								<CircularProgress />
							</div>
							}
							<Button type="button" loading={isLoadingNewQrCode} onClick={() => handlerRecreateSession()}><Refresh />Solicitar novo QR Code</Button>
						</>
					) : (
						<>
							<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
								<p>Aguardando geração do QR Code...</p>
								<CircularProgress />
								<Button type="button" loading disabled onClick={() => handlerRecreateSession()}><Refresh />Solicitar novo QR Code</Button>
							</div>
						</>
					)}
				</>
			)}
			{
				userCanCreateSession && !getQrCode && !status.isAuthenticated && (
					<Button type="button" loading={isCreatingSession} onClick={() => handler()}>Conectar novo número</Button>
				)
			}
			{
				!userCanCreateSession && !qrCode &&
				<>
					<span>Usuário não autorizado</span>
				</>
			}
		</div>
	);
};

export { ConnectionStatus };
